import React, { FunctionComponent, PropsWithChildren } from 'react';

import { default as MuiDialog, DialogProps } from '@mui/material/Dialog';

const Dialog: FunctionComponent<DialogProps> = (
  props: PropsWithChildren<DialogProps>
) => {
  return <MuiDialog {...props}>{props.children}</MuiDialog>;
};

export default Dialog;
